import { render, staticRenderFns } from "./PrintByCustomer.vue?vue&type=template&id=38cab2db&"
import script from "./PrintByCustomer.vue?vue&type=script&lang=js&"
export * from "./PrintByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PrintByCustomer.vue?vue&type=style&index=0&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
